import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetI9ReviewProgressResponseSchema } from "./getI9ReviewProgressSchema";

export const getI9ReviewProgress = (axios: IAxiosInstance) => {
  return async ({ isI9SupplementB }: { isI9SupplementB?: boolean } = {}) => {
    const response = await axios.noRetry.get<
      ZealApiResponse<TGetI9ReviewProgressResponseSchema>
    >("/api/getI9ReviewProgress", {
      params: {
        isI9SupplementB,
      },
    });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
